import { style } from '@vanilla-extract/css';

export const horizontalRuleContainer = style({
  paddingTop: 'var(--wt-content-break-top-margin, var(--wt-content-break-y-margin))',
  paddingBottom: 'var(--wt-content-break-bottom-margin, var(--wt-content-break-y-margin))',
});

export const horizontalRule = style({
  width: 'var(--wt-content-break-width)',
  margin: '0 auto',
  borderTop: 'var(--wt-content-break-thickness) var(--wt-content-break-style) var(--wt-content-break-color)',
});
